var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.5625H4.16667C3.25 2.5625 2.5 3.3125 2.5 4.22917V15.8958C2.5 16.8125 3.25 17.5625 4.16667 17.5625H15.8333C16.75 17.5625 17.5 16.8125 17.5 15.8958V6.72917L13.3333 2.5625ZM15.8333 15.8958H4.16667V4.22917H12.5V7.5625H15.8333V15.8958ZM5.83333 14.2292H14.1667V12.5625H5.83333V14.2292ZM10 5.89583H5.83333V7.5625H10V5.89583ZM5.83333 10.8958H14.1667V9.22917H5.83333V10.8958Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDetails);
export default __webpack_public_path__ + "static/media/account_details.79101aa144ce31adbe211f654d0657d4.svg";
export { ForwardRef as ReactComponent };